import React, { useContext } from 'react'
import { Spinner } from 'react-bootstrap';
import { CommunityContext } from './CommunityContext';
import './CommunityOverview.css'

const CommunityOverview = () => {
  const { communityData, isLoaded } = useContext(CommunityContext)
  return (
    isLoaded? (
      <div id="community-overview">
        <div className='overview-component'>
          <p className='title'>About Us</p>
          <p>{communityData.longDescription}</p>
        </div>
        <div className='overview-component'>
          <p className='title'>Rules</p>
          <p>{communityData.rules}</p>
        </div>
      </div>
    ): 
    <div className='middle-spinner-container'>
      <Spinner animation="border" variant="warning" style={{ width: "10rem", height: "10rem" }}/>
    </div>
  )
}

export default CommunityOverview
